var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(47 52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M24,39h1a2.946,2.946,0,0,1,3,3v1h9a2.946,2.946,0,0,1,3,3v8h5.1A5,5,0,0,1,51,50.1,4.906,4.906,0,0,1,54.9,54H57a.945.945,0,0,0,1-1V38H24Zm-6,0V38H14v4a2.946,2.946,0,0,1,3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M16,42v1H26V42a.945.945,0,0,0-1-1H22V2H20V41H17A.945.945,0,0,0,16,42Zm21,3H5a.945.945,0,0,0-1,1v9H6V49H8v6h2V49h2v6h2V49h2v6h2V49h2v6h2V49h2v6h2V49h2v6h2V49h2v6h2V49h2v6h2V46A.945.945,0,0,0,37,45ZM35,26v3a2.946,2.946,0,0,1-3,3h-.3a1.265,1.265,0,0,0-.7,1v3H41V28.6a1.421,1.421,0,0,0-.2-.6l-1.3-2Zm-4-8h3l-2,2v3h2V20l2-2v3.2l-1,2V24h4V19.4l1.4-.7a1.149,1.149,0,0,0,.6-.9V17a.945.945,0,0,0-1-1H31a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M13,36h5V34H13a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 5,
    height: 2,
    transform: "translate(24 34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M59,34H43v2H59a1,1,0,0,0,0-2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.1bf22104e2b9ddff46593b903efb1208.svg";
export { ForwardRef as ReactComponent };